import React from 'react'
import "./stylesheet/second.css"
import Servicecard from './Servicecard'
import "./stylesheet/mobilesheet/secondM.css"
const Second = () => {
  return (
<>
<section className='second'>
    <div className="left">
    <div className="heading formating"><span>How  will I help You!</span></div>
        <div className="line formating">
            <div className="insideline"></div>
        </div>
        <div className="subtext formating"><span>
        Business Needs Support Always. and I can provide tech support, I  Can help you To develop and Design your website and  also managed your website Time to Time.
        </span>
      
        </div>
        <div className="button"></div>
    </div>
    <div className="right">
     
    <Servicecard/>

    </div>

</section>
</>  )
}

export default Second